import {Methods} from '@newview/infrastructure';
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

/**
 * Api
 */
export class WorkDeliveryRelationApi extends NewviewOaBaseApi {
    public get ControllerName(): any {
        return 'work-delivery-relation'
    }
    /**
     * 推送消息
     * @param params 
     * @returns 
     */
    public sendMessageCenter(UId, Applicant, Business, MsgContent, Miniprogram = ""){
        if (this.isNull(UId)) {
            return;
        }
        let uIds = []
        if (typeof (UId) == "number") {
            uIds = [UId]
        } else {
            uIds = UId.split(",")
        }
        let messageList: any = []
        uIds.forEach((item, index) => {
            if (!this.isNull(item)) {
                messageList.push({
                    projectId: this.$globalData_Plms.itemInfo.id,
                    siId: 0,
                    suId: 0,
                    riId: 0,
                    ruId: parseInt(item),
                    business: Business,
                    caption: Business,
                    msgContent: MsgContent,
                    readRecord: this.$globalData_Plms.itemInfo.subProjectName,
                    // createTime: this.getCurrentTime(),
                    createTime: new Date().toLocaleString().replaceAll("/", "-"),
                    transforMode: "WeChat",
                    status: 1,
                    sendType: !this.isNull(Miniprogram) ? 0 : 1,
                    miniProgram: Miniprogram,
                    sendName: this.isNull(Applicant) ? this.$globalData_Plms.localUser.userTrueName : Applicant
                })
            }
        });
        return this.send(messageList,"sendMessageCenter",Methods.POST)
    }

    /**获取工作成果交付关系 */  TODO  接口 增加连接NVMilestoneBusinessLane表，返回Priority和orderNo
    public getQueryDeliveryWork(userAccount){
        return this.send({userAccount:userAccount},"getQueryDeliveryWork",Methods.GET)
    }

    /**获取全部工作成果交付关系 */
    public queryDeliveryWorkAll() {
        return this.send({},"queryDeliveryWorkAll",Methods.GET)
      }
  
}